import { createContext, useContext, useState } from "react";

interface SelectedTabProviderProps {
  children: React.ReactNode;
}

type LoggedInUserContextType = {
  loggedInUserId?: string;
  setLoggedInUserId: (loggedInUserId?: string) => void;
};

export const LoggedInUserContext = createContext<LoggedInUserContextType>({
  loggedInUserId: undefined,
  setLoggedInUserId: () => {},
});

const LoggedInUserProvider = (props: SelectedTabProviderProps) => {
  const [loggedInUserId, setLoggedInUserId] = useState<string>();

  return (
    <LoggedInUserContext.Provider value={{ loggedInUserId, setLoggedInUserId }}>
      {props.children}
    </LoggedInUserContext.Provider>
  );
};

export default LoggedInUserProvider;

export const useLoggedInUser = () => {
  const { loggedInUserId, setLoggedInUserId } = useContext(LoggedInUserContext);
  return { loggedInUserId, setLoggedInUserId };
};
